// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactNoData_wrapper__1gDbT","textWrapper":"ContactNoData_textWrapper__HnnyY","title":"ContactNoData_title__9oRQ6","description":"ContactNoData_description__oXDml"};